export default 'icon--whatsapp';